export function easeOutCubic(percentage) {
    return 1 - Math.pow(1 - percentage, 3);
}